import React from 'react';
import { connect } from 'react-redux';

import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import { getIntercomServices, IShopItem } from '~/src/api/content/shop/getShopItems';
import Layout from '~/src/features/_layout';
import { Domofon } from '~/src/features/domofon';
import { initialProps } from '~/src/helpers/basePageFunc';
import { TState } from '~/src/store';
import { selectCompanyName } from '~/src/store/selectors/city';

interface DomofonPageProps {
    alias: string,
    city: ICurrentCity,
    products: IShopItem[],
    companyName: string,
}

function DomofonPage({ city, products, companyName }: DomofonPageProps) {
    const description = `
            Подключите видеодомофон от ${companyName} и управляйте через мобильное приложение.
            Пользуйтесь всеми преимуществами умного домофона для квартиры или частного дома уже сегодня.
            Оставьте заявку на сайте или по ☎ ${city.phone}
        `;

    return (
        <Layout
            title={`Домофон – подключить в квартиру от ${companyName} в ${city.cityIn}`}
            description={description}
            withMenu={true}
            withFooter={true}
            withChat={true}
        >
            <Domofon products={products}/>
        </Layout>
    );
}

DomofonPage.getInitialProps = async(options: any) => {
    const { validatedAccessToken } = await initialProps(options, { isNeedAuthData: true });
    const state = options.store.getState();
    const { city: { currentCity: city, provider: { providerId } } } = state;
    const companyName = selectCompanyName(state);

    const products: IShopItem[] = await getIntercomServices(providerId, validatedAccessToken || '') as IShopItem[] || [];

    return ({
        city,
        products,
        companyName,
    });
};

const mapStateToProps = (state: TState) => ({
    action: state.intercom.actionInfo,
});

export default connect(mapStateToProps)(DomofonPage);
